import { render, staticRenderFns } from "./FormsDemo.vue?vue&type=template&id=c85c7f4c&scoped=true&"
import script from "./FormsDemo.vue?vue&type=script&lang=js&"
export * from "./FormsDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85c7f4c",
  null
  
)

export default component.exports